var solid_gauge = function () {
    var instance = {};

    //Set scope variable to init dbtable with options, columns etc
    instance.init = function (scope, componentKey, component) {
        //initalise component properties
        // $('#' + componentKey).hide();
        scope[componentKey] = {};
        scope[componentKey].instance = {};
        scope[componentKey].data = component.init_config;
    };

    /**
     * @param scope
     * @param componentKey
     * @param resultComponentVal
     */
    instance.update = function (scope, componentKey, resultComponentVal) {
        var config_data = scope[componentKey].data;

        //extend the component config with the result data
        $.extend(true, config_data, resultComponentVal.config);
        resultComponentVal.config = config_data;

        function renderIcons() {
            // Render the icon
            if (typeof this.series[0] != 'undefined' && !this.series[0].icon) {
                this.series[0].icon = this.renderer.path(['M', -4, 0, 'L', 3, 0, 'M', 0, -3, 'L', 3, 0, 0, 3])
                    .attr({
                        'class': 'solid_gauge_icon',
                        'stroke': '#ffffff',
                        'stroke-linecap': 'round',
                        'stroke-linejoin': 'round',
                        'stroke-width': 1.8,
                        'zIndex': 10
                    })
                    .add(this.series[0].group);

                this.series[0].icon.translate(
                    this.chartWidth / 2 - 7,
                    this.plotHeight / 2 - this.series[0].points[0].shapeArgs.innerR -
                    (this.series[0].points[0].shapeArgs.r - this.series[0].points[0].shapeArgs.innerR) / 2
                );
            }

        }
        //Add the render event
        resultComponentVal.config.options.chart.events = { render : renderIcons};

        var dataLabelsObj = {
            "enabled":true,
            "borderWidth": 0,
            "color": "#000000",
            "useHTML": true,
            "style": {
                "fontSize": "21px",
                "fontFamily": "Arial, Helvetica, sans-serif"
            },
            // "format": "<span style=\"font-size:1em; color: {point.color}; font-weight: bold\">{point.y}%</span>",
            "x": 0,
            "y": -20,
            "formatter": function(){
                if(typeof this.point.previous != 'undefined')
                {
                    var previous_data = typeof this.point.previous != 'undefined'?this.point.previous:null;
                    var arrow_up_color = typeof this.point.arrow_up_color != 'undefined'?this.point.arrow_up_color : 'green';
                    var arrow_down_color = typeof this.point.arrow_down_color != 'undefined'?this.point.arrow_down_color : 'red';
                    var null_data_display = typeof this.point.null_data_display != 'undefined'? this.point.null_data_display : '-';
                    var show_comparison_arrow = typeof this.point.show_comparison_arrow != 'undefined' && this.point.show_comparison_arrow === 'true' ? 'true' : 'false';
                    var display_as_percentage = typeof this.point.display_as_percentage != 'undefined' && this.point.display_as_percentage === 'true' ? 'true' : 'false';
                    var css_class = (this.y < 0) ? "datalabel datalabel-negative" : "datalabel";

                    //One decimal even for integers
                    if(typeof config_data.options.round != 'undefined') {
                        this.y = this.y.toFixed(config_data.options.round);
                    }

                    var display_metric = this.y;

                    if (display_as_percentage === 'true')
                    {
                        display_metric = display_metric + '<span style="font-size:0.7em">%</span>';
                    }

                    if(previous_data !== null)
                    {
                        if (show_comparison_arrow === 'true')
                        {
                            if(this.y > this.point.previous) {
                                return '<span data-toggle="tooltip" data-html="true" data-title="<increase-caret></inscrease-caret> Increase from last period." class="'+css_class+'">'+display_metric+' <i style="color:'+arrow_up_color+';font-size: 18px; vertical-align: middle;" class="fa fa-caret-up fa-lg"></i></span>';
                            }
                            if(this.y<this.point.previous) {
                                return '<span data-toggle="tooltip" data-html="true" data-title="<decrease-caret></decrease-caret> Decrease from last period." class="'+css_class+'">'+display_metric+' <i style="color:'+arrow_down_color+';font-size: 18px; vertical-align: middle;" class="fa fa-caret-down fa-lg" /></span>';
                            }
                            return '<span class="'+css_class+'">'+display_metric+'</span>';
                        }
                        else
                        {
                            return '<span class="'+css_class+'">'+display_metric+'</span>';
                        }
                    }
                    else
                    {
                        return '<span class="'+css_class+'">'+null_data_display+'</span>';
                    }
                }
                return Highcharts.numberFormat(this.y,1);
            }
        };
        resultComponentVal.config.options.plotOptions.solidgauge.dataLabels = dataLabelsObj;

        // apply component settings
        if (typeof resultComponentVal.config.series != 'undefined')
        {
            for (first_series_name in resultComponentVal.config.series) break;

            if (typeof resultComponentVal.config.series[first_series_name] != 'undefined' &&
                typeof resultComponentVal.config.series[first_series_name].component_config != 'undefined')
            {
                if (typeof resultComponentVal.config.series[first_series_name].component_config.gauge_color != 'undefined')
                {
                    resultComponentVal.config.yAxis.stops[0][1] = resultComponentVal.config.series[first_series_name].component_config.gauge_color;
                }

                if (typeof resultComponentVal.config.series[first_series_name].component_config.max_score != 'undefined')
                {
                    resultComponentVal.config.yAxis.max = resultComponentVal.config.series[first_series_name].component_config.max_score;
                }
            }
        }

        //reset component properties
        scope[componentKey] = {};
        scope[componentKey].instance = {};

        //update component
        scope[componentKey].data = resultComponentVal.config;
    };

    return instance;
};
